import { makeStyles, tokens } from "../shared";

export const portalAnchorStyles = makeStyles({
  root: {
    color: tokens.colorBrandForeground1,
    fontWeight: tokens.fontWeightSemibold,
    backgroundColor: "transparent",
  },
});
